module.exports = __webpack_public_path__ + "img/b4.ffbe149c.jpg";